<script setup>

</script>

<template>
  <div>
    Le serveur est actuellement injoignable
  </div>
</template>

<style scoped>

</style>
